import { AuthService } from "src/app/core/endpoints/auth.service";
import { Utils } from "src/app/app.utils";
import { Component, OnInit } from "@angular/core";
import { AppConfig } from "src/app/api/appconfig";
import { ApiService } from "src/app/core/services/api.service";

@Component({
	templateUrl: "./dashboard.component.html",
	styleUrls: ["./dashboard.component.scss"],
})
export class DashboardComponent implements OnInit {
	public operation: "ME" = "ME";
	public loading = false;
	public chartOptions: any;
	public config: AppConfig;
	public location: any;
	public stringLocation: any;
	public locationGps: any;
	public data: any;
	versionApp:any = "";

	constructor(public utils: Utils, private apiService: ApiService) {
		this.getDashboardData();
	}

	ngOnInit() {
		this.versionApp = localStorage.getItem('versionApp');
		// this.notificationService.requestPermission();
	}
	
	loadVersion(){
		this.apiService.getEntity('version').subscribe({
		  next: (response) => {
			this.versionApp = response;
			localStorage.setItem('versionApp',this.versionApp);
		  }
		});
	}

	getUser() {
		return AuthService.getDataUser();
	}

	/**
	 * Obtención de datos para pantalla de inicio
	 */
	public getDashboardData() {
		this.loading = true;
		this.apiService.getEntity("dashboard").subscribe({
			next: async (data) => {
				this.data = data;
				this.loading = false;
			},
			error: (error) => {
				console.log(error);
				this.loading = false;
			},
			complete: () => {
				this.loading = false;
			},
		});
	}
}
